import { useApi } from '@omnipresentgroup/api';
import type { ExportExpensesRequest } from '@omnipresentgroup/types';
import { useCallback } from 'react';

import { API_PATH, COMPENSATION_API_BASE } from '../constants';
import { transformExportExpensesRequestToAPI } from '../mappers';

export const useExportExpenses = () => {
  const { fetchWithToken } = useApi();

  const downloadExpenses = useCallback(
    async (payload: ExportExpensesRequest) => {
      const response = await fetchWithToken({
        path: `${COMPENSATION_API_BASE}/${API_PATH}/export`,
      });
      return response.post(transformExportExpensesRequestToAPI(payload)).text();
    },
    [fetchWithToken],
  );

  return {
    downloadExpenses,
  };
};
